import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { loginActions } from './actions';
import {
  LOGIN_FAILURE,
  LOGIN_INIT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_REQUEST,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGIN_INIT_SUCCESS,
  LOGIN_INIT_FAILURE,
  AUTO_LOGIN_REQUEST,
  AUTO_LOGIN_SUCCESS,
  AUTO_LOGIN_FAILURE,
} from '../../constants/login';
import { Credentials } from '../../types/Login';

export type LoginState = {
  readonly user: Credentials | null;
  readonly isLoading: boolean;
  readonly error: string | null;
  readonly requested: boolean;
  readonly autoLoginRequested: boolean;
  readonly autoLoginIsLoading: boolean;
};
export type LoginActions = ActionType<typeof loginActions>;

export const loginReducer = combineReducers<LoginState, LoginActions>({
  user: (state = null, action) => {
    switch (action.type) {
      case LOGIN_SUCCESS:
      case SIGNUP_SUCCESS:
      case AUTO_LOGIN_SUCCESS:
      case LOGIN_INIT_SUCCESS:
        return action.payload.userData;
      case LOGOUT_REQUEST:
      case SIGNUP_REQUEST:
        return null;
      default:
        return state;
    }
  },
  requested: (state = false, action) => {
    switch (action.type) {
      case LOGIN_INIT:
        return true;
      default:
        return state;
    }
  },
  autoLoginRequested: (state = false, action) => {
    switch (action.type) {
      case AUTO_LOGIN_REQUEST:
        return true;
      default:
        return state;
    }
  },
  autoLoginIsLoading: (state = false, action) => {
    switch (action.type) {
      case AUTO_LOGIN_REQUEST:
        return true;
      case AUTO_LOGIN_SUCCESS:
      case AUTO_LOGIN_FAILURE:
        return false;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case LOGIN_REQUEST:
      case AUTO_LOGIN_REQUEST:
      case LOGIN_INIT:
      case SIGNUP_REQUEST:
      case LOGOUT_REQUEST:
        return true;
      case LOGIN_INIT_FAILURE:
      case LOGIN_SUCCESS:
      case LOGIN_FAILURE:
      case SIGNUP_SUCCESS:
      case SIGNUP_FAILURE:
      case LOGOUT_SUCCESS:
      case LOGOUT_FAILURE:
      case AUTO_LOGIN_SUCCESS:
      case LOGIN_INIT_SUCCESS:
      case AUTO_LOGIN_FAILURE:
        return false;
      default:
        return state;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case LOGIN_FAILURE:
      case SIGNUP_FAILURE:
      case LOGIN_INIT_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
